import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { OperacionService } from '../../../services/operaciones/operacion/operacion.service';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-notificar-solicitud-desembolso',
  templateUrl: './notificar-solicitud-desembolso.component.html',
  styleUrls: ['./notificar-solicitud-desembolso.component.scss']
})
export class NotificarSolicitudDesembolsoComponent implements OnInit {

  @Input() notificarSoliDes : any;
  @Output() cerrarNotificarSoliDes : EventEmitter<boolean>;

  idEmpresa : number = 0;
  idProveedor : number = 0;
  rsProveedor : string;
  frmContactos : FormGroup;
  rProvCombo : any = [];
  rProvArray : any = [];
  loading : boolean = false;
  save : boolean = false;
  error : boolean = false;
  textError: string = "";

  constructor(
    private operacionService:OperacionService,
    private empresasService:EmpresasService,
    private routerActive:ActivatedRoute) { 
    
    this.routerActive.params.subscribe( params => {
      this.cerrarNotificarSoliDes = new EventEmitter();
      this.idEmpresa = params['id'];      
    })

    this.frmContactos = new FormGroup({
    "idSolicitudDesembolso": new FormControl('',  Validators.required),
    "idProvRepresentante":new FormControl('', Validators.required),
    "ProvNombre":new FormControl('', Validators.required),
    "provCorreoElectronico":new FormControl('', Validators.required),
    "provNumero":new FormControl('', Validators.required)
   });
  }

  ngOnInit() {
    this.rsProveedor = this.notificarSoliDes.pNomComercial;
    this.frmContactos.controls['idSolicitudDesembolso'].setValue(this.notificarSoliDes.idSolicitudDesembolso);
    this.idProveedor = this.notificarSoliDes.idProveedor;
    this.ListarRepresentantesProv(this.idProveedor);
  }

  ListarRepresentantesProv(idProv){
    this.loading = true;
    this.empresasService.obtenerContactosEmpresa(idProv).subscribe(
      res => {       
          this.rProvCombo = res;
          this.rProvCombo = this.rProvCombo.filter(
            state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 && state.Rol_Del_Contacto_Dsc.toLowerCase().indexOf('representante') === 0
          );
          this.loading = false;
          if(this.rProvCombo.length == 0){
            Swal.fire('Por favor registrar un representante legal')
          }
      },err =>{
        this.textError = err.error['error'];
        this.error = true;
        this.loading = false;
      }
    );
  }

  SetearCorreo(idContacto){
    if(this.rProvCombo.length > 0){
      this.rProvArray = this.rProvCombo.filter(
        state => state.idContacto == idContacto
      );
      this.frmContactos.controls['idProvRepresentante'].setValue(this.rProvArray[0].idContacto);
      this.frmContactos.controls['ProvNombre'].setValue(this.rProvArray[0].Nombre_de_Contacto);
      this.frmContactos.controls['provCorreoElectronico'].setValue(this.rProvArray[0].Correo);
      this.frmContactos.controls['provNumero'].setValue(this.rProvArray[0].NroMovil_Laboral);
    }
  }

  CerrarPopUp(){
    this.cerrarNotificarSoliDes.emit();
  }

  enviarCorreo(){

    if(this.frmContactos.invalid){
      return false;
    }

    this.operacionService.notificarSoliDes(this.frmContactos.getRawValue()).subscribe(
      res => {
        this.showNotification('success','top','right','Correo enviado exitosamente.');
      },err =>{
        let error = "";
        error = err.error.error;
        this.showNotification('danger','top','right','No se pudo enviar correo electrónico. \n' + error);
      });
      this.CerrarPopUp();
    }
  showNotification(type,from,align,message){
        $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}

